import cn from 'mxcn';
import { IconSparkles } from './icons';
import { CustomStylesI } from '.';
import { useIsDarkMode } from './hooks/use-is-dark-mode';
import { useState } from 'react';

export const Suggestions = ({
	suggestions,
	sendSuggestedPrompt,
	customStyles
}: {
	suggestions: { title: string; prompt: string }[];
	sendSuggestedPrompt: (prompt: string) => void;
	customStyles?: CustomStylesI;
}) => {
	const isDarkMode = useIsDarkMode();
	const [isHovered, setIsHovered] = useState(false);

	const handleClick = (prompt: string) => {
		sendSuggestedPrompt(prompt);
	};

	return (
		<div className="lb-mx-auto lb-mt-8 lb-max-w-4xl">
			<label
				className={cn(
					'lb-text-sm lb-font-semibold lb-text-muted-foreground'
				)}
				style={{
					...(customStyles?.chatbot?.foregroundColor && {
						color: !isDarkMode
							? customStyles?.chatbot?.foregroundColor
							: customStyles?.chatbot?.backgroundColor
					})
				}}
			>
				Suggestions
			</label>
			<div className="lb-grid lb-grid-cols-1 lb-gap-4 lb-pt-4 md:lb-grid-cols-2">
				{suggestions.map((suggestion, index) => {
					return (
						<div
							key={index}
							className={cn(
								'lb-flex lb-cursor-pointer lb-items-center lb-gap-4 lb-rounded-md lb-border lb-border-solid lb-border-muted-foreground/20 lb-p-4 lb-text-sm',
								'lb-transition-colors lb-duration-200 hover:lb-bg-secondary/60'
							)}
							onClick={() => handleClick(suggestion.prompt)}
							style={{
								...(customStyles?.chatbot?.foregroundColor && {
									borderColor: !isDarkMode
										? customStyles?.chatbot?.foregroundColor
										: customStyles?.chatbot?.backgroundColor
								})
							}}
						>
							<IconSparkles
								className="lb-size-4 lb-text-muted-foreground"
								aria-hidden="true"
								style={{
									...(customStyles?.chatbot
										?.foregroundColor && {
										color: !isDarkMode
											? customStyles?.chatbot
													?.foregroundColor
											: customStyles?.chatbot
													?.backgroundColor
									})
								}}
							/>
							<p
								className="lb-line-clamp-2 lb-font-light lb-leading-6 lb-text-foreground/70"
								style={{
									...(customStyles?.chatbot
										?.foregroundColor && {
										color: !isDarkMode
											? customStyles?.chatbot
													?.foregroundColor
											: customStyles?.chatbot
													?.backgroundColor,
										opacity: 0.7
									})
								}}
							>
								{suggestion.title}
							</p>
						</div>
					);
				})}
			</div>
		</div>
	);
};
